<template>
  <v-container>
    <v-empty-state
      v-if="loaded && !topos.length"
      icon="mdi-map-legend"
      size="64"
      title="Aucune carte topo pour cette section"
    ></v-empty-state>
    <v-row v-else-if="topos.length">
      <!-- Main viewer: zoom, pan and fullscreen on the selected topo -->
      <v-col ref="viewer" cols="12" :md="topos.length > 1 ? 8 : 12">
        <div class="topo-viewer">
          <zoomable-image
            :src="currentTopo.url"
            :caption="currentTopo.description"
            :has-previous="currentIndex > 0"
            :has-next="currentIndex < topos.length - 1"
            @previous="selectTopo(currentIndex - 1)"
            @next="selectTopo(currentIndex + 1)"
          ></zoomable-image>
        </div>
        <div class="d-flex align-start flex-wrap ga-2 mt-3">
          <p v-if="currentTopo.description" class="text-body-large mb-0 flex-grow-1">{{ currentTopo.description }}</p>
          <span class="text-body-small text-medium-emphasis">
            Molette ou pincement pour zoomer, glisser pour se déplacer
          </span>
        </div>
      </v-col>
      <v-col v-if="topos.length > 1" cols="12" md="4">
        <div class="text-label-large text-medium-emphasis mb-2">{{ topos.length }} cartes topo</div>
        <v-list density="compact" class="py-0 topo-list">
          <v-list-item
            v-for="(topo, index) in topos"
            :key="topo.url"
            :active="index === currentIndex"
            color="primary"
            rounded="lg"
            class="mb-1 px-2"
            @click="selectTopo(index, true)"
          >
            <template #prepend>
              <div class="topo-thumb mr-3">
                <img :src="topo.url" alt="" loading="lazy" />
              </div>
            </template>
            <v-list-item-title class="text-body-medium topo-title">
              {{ topo.description || `Carte topo ${index + 1}` }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import ZoomableImage from "@/components/ZoomableImage.vue";
  import { SectionMediaService } from "@/services/SectionMedia.service";

  export default {
    components: { ZoomableImage },
    props: {
      section: {
        type: Object,
        default: function () {
          return {};
        },
      },
    },
    data() {
      return {
        topos: [],
        currentIndex: 0,
        loaded: false,
      };
    },
    computed: {
      currentTopo() {
        return this.topos[this.currentIndex] || this.topos[0];
      },
    },
    async mounted() {
      try {
        if (this.section.topo_info) {
          await this.getSectionTopo();
        }
      } catch (error) {
        console.error("Error loading topos:", error);
      } finally {
        this.loaded = true;
      }
    },
    methods: {
      // Signed URLs that expire: see SectionMedia.service.js
      async getSectionTopo() {
        const topos = await SectionMediaService.getTopos(this.section.id);
        this.topos = topos.filter((topo) => topo && topo.url);
      },
      selectTopo(index, fromList = false) {
        this.currentIndex = index;
        // On small screens the list is below the viewer: bring the viewer back into view
        if (fromList && this.$vuetify.display.smAndDown && this.$refs.viewer) {
          this.$refs.viewer.$el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .topo-viewer {
    height: 70vh;
    min-height: 320px;
  }
  .topo-list {
    max-height: 70vh;
    overflow-y: auto;
  }
  .topo-thumb {
    flex: 0 0 auto;
    width: 112px;
    aspect-ratio: 4 / 3;
    border-radius: 6px;
    overflow: hidden;
    background: rgb(var(--v-theme-surface-variant));

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .topo-title {
    white-space: normal;
    line-height: 1.3;
  }
</style>
